<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="top_box flex Flexjustify Flexalign">
      <div class="top_bg" :style="getBgImg(courseDetail)"></div>
      <div class="top_bg_black"></div>
      <div class="top_content flex">
        <div class="top_left flex flexcolumn">
          <div class="course_top_text">
            <span class="cursor_pointer" @click="href('/')">首页</span> >
            {{ courseDetail.subjectName }} >
            <span class="course_title">{{ courseDetail.courseName }}</span>
          </div>
          <div class="flex top_left_content flex-1 FlexBetween">
            <div class="flex flex-1">
              <el-image class="vedio_img" :src="imgPath(courseDetail.courseCoverImg)"></el-image>
              <div class="video_info flex flex-1 flexcolumn FlexBetween">
                <div class="video_title toverflows toverflow2">
                  {{ courseDetail.courseName }}
                </div>
                <div class="subtitle toverflows toverflow2">
                  {{ courseDetail.courseSname }}
                </div>
                <div class="flex info_desc">
                  <div class="info_label">
                    <div class="mar_top_10">评分：</div>
                    <div class="mar_top_10">课程难度：</div>
                    <div class="mar_top_10">学科：</div>
                    <div class="mar_top_10">时长：</div>
                  </div>
                  <div class="info_value">
                    <div class="mar_top_10 mar_left_20">
                      {{
                        $Tools.scoreToStar(courseDetail.courseExtra?.appraiseScore) ||
                        "暂无评分"
                      }}
                    </div>
                    <div class="mar_top_10 mar_left_20">
                      {{ getDictObject("difficulty", courseDetail.courseDifficulty) }}
                    </div>
                    <div class="mar_top_10 mar_left_20">
                      {{ courseDetail.subjectName }}
                    </div>
                    <div class="mar_top_10 mar_left_20">
                      {{
                        $Tools.secondToHour(
                          courseDetail.chapterCountResult?.videoDuration
                        )
                      }}
                    </div>
                  </div>
                  <div class="info_label mar_left_40">
                    <div class="mar_top_10">学习人数：</div>
                    <div class="mar_top_10">学段：</div>
                    <div class="mar_top_10">课时：</div>
                    <div class="mar_top_10">最新更新：</div>
                  </div>
                  <div class="info_value">
                    <div class="mar_top_10 mar_left_20">
                      {{ courseDetail.courseExtra?.userNum }}
                    </div>
                    <div class="mar_top_10 mar_left_20">
                      {{ courseDetail.gradeName }}
                    </div>
                    <div class="mar_top_10 mar_left_20">
                      {{ courseDetail.chapterCountResult?.chapterNum }}
                    </div>
                    <div class="mar_top_10 mar_left_20">
                      {{ courseDetail.updateTime?.split(" ")[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="top_right_content flex flexcolumn Flexalign">
              <el-image class="follow_icon cursor_pointer" :src="imgPath('follow_icon.png')" v-if="!collected"
                @click="collectCourse(true)"></el-image>
              <el-image class="follow_icon cursor_pointer" :src="imgPath('collected_icon.png')" v-if="collected"
                @click="collectCourse(false)"></el-image>
              <div class="flex follow_box">
                <div v-if="!collected">收藏</div>
                <div v-if="collected">已收藏</div>
                <!-- <div class="mar_left_15">{{ courseDetail.courseExtra?.collectNum }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_box flex Flexjustify Flexalign">
      <div class="content flex">
        <div class="content_left">
          <div class="institution_info flex FlexBetween Flexalign">
            <div class="institution_info_left flex Flexalign flex-1">
              <el-image class="avatar_img" :src="imgPath(courseDetail.shopLogo)"></el-image>
              <div class="flex flexcolumn insitution_content">
                <div class="flex Flexalign">
                  <div class="institution_name">
                    {{ courseDetail.shopName }}
                  </div>
                  <!-- <el-image class="institution" :src="imgPath(institutionInfo.authentication)"></el-image> -->
                </div>
                <div class="institution_desc toverflow">{{ courseDetail.shopBrief }}</div>
                <!-- <div class="institution_desc" v-if="courseDetail.shopBrief">
                  <div v-html="$Tools.handlerImg(courseDetail.shopBrief)"></div>
                </div> -->
              </div>
            </div>
            <div class="flex btn btn_follow Flexjustify Flexalign cursor_pointer" v-if="!shopCollected"
              @click="collectShopCourse(true)">
              <el-image class="collect_icon" :src="imgPath('collect_icon.png')"></el-image>
              <div>关注</div>
            </div>
            <div class="flex btn btn_follow btn_followed Flexjustify Flexalign cursor_pointer" v-if="shopCollected"
              @click="collectShopCourse(false)">
              <div>已关注</div>
            </div>
          </div>
          <div class="lecturer_info mar_top_20">
            <div class="menu_list flex">
              <div class="menu_one flex flexcolumn Flexalign cursor_pointer" v-for="(item, index) in menuList"
                :key="index" @click="chaneMenu(item)">
                <div :class="[item.value == selectMenu ? 'active_text' : '']">
                  {{ item.label }}
                </div>
                <div :class="[item.value == selectMenu ? 'line_active' : '']"></div>
              </div>
            </div>
            <div>
              <teacherInfo v-if="selectMenu == 0"></teacherInfo>
              <courseIntroduce v-if="selectMenu == 1" :courseIntroduce="courseDetail.courseIntro"></courseIntroduce>
              <courseOutline v-if="selectMenu == 2" :courseId="courseId" :courseDetail="courseDetail"
                :isAleadyJoin="isAleadyJoin"></courseOutline>
              <discuss v-if="selectMenu == 3" :courseId="courseId"></discuss>
              <evaluateList :courseDetail="courseDetail" :courseId="courseDetail.courseId" v-if="selectMenu == 4"
                :isAleadyJoin="isAleadyJoin">
              </evaluateList>
              <courseware v-if="selectMenu == 5" :courseId="courseId"></courseware>
              <timeTable v-if="selectMenu == 6" :courseSettingInfo="courseSettingInfo"></timeTable>
            </div>
          </div>
          <div class="course_list_box">
            <div class="flex FlexBetween">
              <div class="recommend">推荐课程</div>
              <div class="more_btn flex Flexalign Flexjustify cursor_pointer" @click="goCourseList">
                更多
                <div class="flex Flexalign" style="margin-left: 5px">
                  <el-icon :size="18">
                    <ArrowRight color="rgba(102, 102, 102, 1)" />
                  </el-icon>
                </div>
              </div>
            </div>
            <courseList :courseDetail="courseDetail"></courseList>
          </div>
          <div class="advertisement_box flex FlexBetween" v-if="advertisementList.length">
            <div class="advertisement_one" v-for="(item, index) in advertisementList" :key="index">
              <el-image class="advertisement_img" :src="imgPath(item?.picture)"
                @click="goBannerLink(item?.link)"></el-image>
            </div>
          </div>
        </div>
        <div class="content_right">
          <div class="top_banner_right flex flexcolumn" :style="{
            height: `${courseDetail.styleSettingMode == 1 ? '560px' : 'auto'}`,
          }">
            <div class="flex flexcolumn Flexalign FlexEvenly top_banner_right_top" :style="{
              height: `${courseDetail.styleSettingMode == 1 ? '310px' : 'auto'}`,
            }">
              <div class="video_play_box flex flexcolumn Flexalign Flexjustify">
                <el-image class="video_img" :src="imgPath(courseDetail.courseCoverImg)"></el-image>
                <!-- <el-image class="play_icon" :src="imgPath('play_icon.png')"></el-image>
                <div class="play_text">免费试看</div> -->
              </div>
              <div class="price_box flex FlexBaseline FlexjustifyStart" v-if="courseDetail.styleSettingMode == 1">
                <div class="flex FlexBaseline" v-if="courseDetail.saleMethod == 2">
                  <div class="now_price">
                    <span>￥</span><span class="now_price_value">{{
                      courseDetail.saleMethod == 2 ? courseDetail.coursePrice : 0
                    }}</span>
                  </div>
                  <div class="original_price">
                    <span>￥</span>{{ courseDetail.courseOriginalPrice }}
                  </div>
                </div>
                <div v-else>免费</div>
              </div>
              <skuList :product-id="123" @buy="handleBuy" :specConfig="courseDetail.specConfig"
                @spec-change="handleSpecChange" v-if="courseDetail.styleSettingMode == 2"></skuList>
              <div style="width: 100%">
                <div class="btn_free_learn btn_buy cursor_pointer" @click="goLearning(isAleadyJoin ? 'buy' : 'free')"
                  v-if="courseDetail.saleMethod == 1">
                  {{ isAleadyJoin ? "立即学习" : "免费参与学习" }}
                </div>
                <div class="flex Flexalign FlexBetween buy_btn_box">
                  <div class="add_car cursor_pointer" @click="addCar(1)"
                    v-if="courseDetail.saleMethod == 2 && isAleadyJoin == false">
                    加入购物车
                  </div>
                  <div class="btn_buy cursor_pointer" @click="addCar(2)"
                    v-if="courseDetail.saleMethod == 2 && isAleadyJoin == false"
                    :class="courseDetail.styleSettingMode == 2 ? 'ml-30' : ''">
                    立即购买 {{ courseDetail.styleSettingMode == 2 ? '￥ ' + selectSkuInfo.price : '' }}
                  </div>
                </div>
                <div class="btn_buy cursor_pointer" @click="goLearning('buy')"
                  v-if="courseDetail.saleMethod == 2 && isAleadyJoin">
                  立即学习
                </div>
              </div>
            </div>
            <div class="top_banner_right_bottom flex-1 flex FlexEvenly flexcolumn"
              v-if="courseDetail.styleSettingMode == 1">
              <div class="newest_course">最新课程</div>
              <div v-for="(item, index) in newCourseList" :key="index"
                class="toverflow active_course cursor_pointer course-item" @click="goDetail(item)">
                {{ item.courseName }}
              </div>
            </div>
          </div>
          <recommendCourseList :courseDetail="courseDetail"></recommendCourseList>
        </div>
      </div>
    </div>
    <buyFreeCourse ref="buyFreeCourse"></buyFreeCourse>
    <moe-bottom></moe-bottom>
    <moe-right :showCustomer="{ showCustomer: true }" :companionTeacherQrcode="courseSettingInfo.companionTeacherQrcode"
      :shopId="courseDetail.shopId" :shopInfo="{
        shopId: courseDetail.shopId,
        shopName: courseDetail.shopName,
        shopLogo: courseDetail.shopLogo,
      }" ref="moeRight"></moe-right>
  </moe-page>
</template>
<script>
import teacherInfo from "./components/teacherInfo.vue";
import courseIntroduce from "./components/courseIntroduce.vue";
import courseList from "./components/courseList.vue";
import courseOutline from "./components/courseOutline.vue";
import evaluateList from "./components/evaluateList.vue";
import courseware from "./components/courseware.vue";
import discuss from "./components/discuss.vue";
import filter from "@/mixins/filter";
import recommendCourseList from "./components/recommendCourseList.vue";
import buyFreeCourse from "@/components/popup/buyFreeCourse.vue";
import { debounce } from "@/assets/utils/dbucTrtl";
import { mapState } from "vuex";
import timeTable from "./components/timeTable.vue";
import skuList from "./components/skuList.vue";
export default {
  name: "GjkcH5Detail",
  components: {
    teacherInfo,
    courseIntroduce,
    courseList,
    courseOutline,
    evaluateList,
    courseware,
    discuss,
    recommendCourseList,
    buyFreeCourse,
    timeTable,
    skuList,
  },
  mixins: [filter],
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      selectCourseType: (state) => state.user.selectCourseType,
    }),
  },
  data() {
    return {
      courseId: "",
      courseDetail: {},
      // 配置的课程权限
      courseSettingInfo: {},
      courseInfo: {},
      institutionInfo: {},
      menuList: [
        // { label: "主讲老师", value: 0 },
        { label: "课程介绍", value: 1 },
        { label: "课程大纲", value: 2 },
        { label: "师生问答", value: 3 },
        { label: "学员评价", value: 4 },
        // { label: "课件资料", value: 5 },
        // { label: "课程课表", value: 6 },
      ],
      selectMenu: 1,
      advertisementList: [
        // { img: "banner.png", link: "" },
        // { img: "advertisement_img.png", link: "" },
      ],
      courseChapterList: [],
      collectParams: {
        collectType: 3,
        associatedIds: "",
      },
      collected: false, // 是否收藏
      shopCollected: false, // 是否收藏机构
      isAleadyJoin: false, // 是否参与学习
      newCourseList: [], // 最新课程
      selectSkuInfo: {}
    };
  },
  watch: {
    // 监听 $route 对象或特定参数
    $route(to, from) {
      if (to.query.courseId != from.query.courseId) {
        this.courseId = to.query.courseId;
        this.getCourseDetail();
        this.setCourseInfo();
        this.getCollectInfo();
      }
    },
    selectCourseType: {
      handler() {
        this.getCourseList();
        this.getBannerList();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.courseId = this.$Jump.getUrlParams(window.location.hash.split("?")[1])?.courseId;
    this.getCourseDetail();
    this.setCourseInfo();
    this.getCollectInfo();
    this.getSchemeByCourseId();
    this.getPhaseList();
  },

  methods: {
    handleSpecChange({ specs, sku }) {
      console.log('规格变化:', specs, sku)
      this.selectSkuInfo = sku;
    },
    handleBuy(skuInfo) {
      console.log("购买的商品信息:", skuInfo);
    },
    // 阶段字典列表
    getPhaseList() {
      this.$Api.course
        .getPhaseList()
        .then((res) => {
          // 设置缓存
          this.$store.commit("learning/setPhaseList", res.data.data);
        })
        .catch(() => { });
    },
    // 获取课程方案列表
    getSchemeByCourseId() {
      this.$Api.course
        .getSchemeByCourseId(this.courseId)
        .then((res) => {
          // this.schemeList = res.data.data;
          // this.schemeId = res.data.data[0]?.schemeId;
          // 设置缓存
          this.$store.commit("learning/setCourseScheme", res.data.data[0]?.schemeId);
        })
        .catch(() => { });
    },
    // 顶部背景图
    getBgImg(info) {
      return {
        backgroundImage: `url(${info.courseCoverImg})`,
        backgroundSize: `100% 100%`,
        filter: `blur(15px)`,
      };
    },
    // 详情
    goDetail(info) {
      this.$Jump.href("/courseDetail", { courseId: info.courseId });
    },
    // 获取最新课程
    getCourseList() {
      let selectedInfo = {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 5, // 单页数量
        orderByColumn: "", // 排序字段
        isAsc: "desc", //升降序
        stageIds: this.userInfo.atStageIds, // 用户所属学段
        // subjectIds: this.userInfo.atSubjectIds  // 用户兴趣爱好所选学科
        typeId: this.selectCourseType, // 课程类型
      };
      this.$Api.course
        .getCourseList(selectedInfo)
        .then((res) => {
          this.newCourseList = res.data.data.list;
        })
        .catch(() => { });
    },
    // 获取banner轮播图
    getBannerList() {
      let leftBannerId = 4;
      let rightBannerId = 7;
      if (this.selectCourseType == 1) {
        leftBannerId = 13;
        rightBannerId = 14;
      }
      if (this.selectCourseType == 2) {
        leftBannerId = 16;
        rightBannerId = 17;
      }
      if (this.selectCourseType == 3) {
        leftBannerId = 19;
        rightBannerId = 20;
      }
      this.$Api.common
        .getBannerList({ id: leftBannerId })
        .then((res) => {
          this.advertisementList[0] = res.data.data[0];
        })
        .catch(() => { });
      this.$Api.common
        .getBannerList({ id: rightBannerId })
        .then((res) => {
          this.advertisementList[1] = res.data.data[0];
        })
        .catch(() => { });
    },
    goBannerLink(link) {
      if (link) {
        window.open(link);
      }
    },
    chaneMenu(info) {
      this.selectMenu = info.value;
    },
    // 课程详情
    getCourseDetail() {
      this.$Api.course
        .getCourseDetail(this.courseId)
        .then((res) => {
          this.courseDetail = res.data.data;
          this.getShopCollectInfo();
          this.hasAlreadyJoin();
        })
        .catch(() => { });
    },
    // 是否已参与学习（已购买）
    hasAlreadyJoin() {
      this.$Api.course
        .hasAlreadyJoin(this.courseId)
        .then((res) => {
          if (!this.$Tools.empty(res.data.data)) this.isAleadyJoin = true;
        })
        .catch(() => { });
    },
    // 去学习
    goLearning(type) {
      if (type == "free") {
        // 调接口免费学习后再弹窗
        this.$Api.course
          .joinFreeCourse({ courseId: this.courseId })
          .then(() => {
            this.$refs.buyFreeCourse.buyFreeCourseShow = true;
            this.$refs.buyFreeCourse.courseId = this.courseId;
            this.hasAlreadyJoin(); // 刷新是否购买
            // this.$Jump.href("/onlineLearning", { courseId: this.courseId });
          })
          .catch(() => { });
      } else {
        this.$Jump.href("/onlineLearning", { courseId: this.courseId });
      }
    },
    // 课程设置信息
    setCourseInfo() {
      this.$Api.course
        .setCourseInfo(this.courseId)
        .then((res) => {
          this.courseSettingInfo = res.data.data;
          this.courseSettingInfo.schoolTimetable = this.$Tools.handlerImg(
            this.courseSettingInfo.schoolTimetable
          );
          let tableIndex = this.menuList.findIndex((item) => item.label == "课程课表");
          if (tableIndex == -1 && this.courseSettingInfo.schoolTimetableEnabled != 0) {
            this.menuList.push({ label: "课程课表", value: 6 });
          }
          this.$refs.moeRight.getMenuList(this.courseSettingInfo.companionTeacherQrcode);
        })
        .catch(() => { });
    },
    // 课程收藏关系
    getCollectInfo() {
      this.collectParams.associatedIds = this.courseId;
      this.collectParams.collectType = 3;
      this.$Api.course
        .getCollectInfo(this.collectParams)
        .then((res) => {
          const idx = res.data.data.findIndex((item) => item == this.courseId);
          if (idx != -1) {
            this.collected = true;
          } else {
            this.collected = false;
          }
        })
        .catch(() => { });
    },
    // 收藏
    collectCourse(flag) {
      this.collectedCourse(flag);
    },
    collectedCourse: debounce(
      function (flag) {
        this.$Api.course
          .collectCourse({ courseId: this.courseId })
          .then((res) => {
            console.log(res);
            if (flag) {
              this.$Dialog.toast("收藏成功");
              ++this.courseDetail.courseExtra.collectNum;
            } else {
              this.$Dialog.toast("已取消收藏", { type: "warning" });
              --this.courseDetail.courseExtra.collectNum;
            }
            this.getCollectInfo();
          })
          .catch(() => { });
      },
      1000,
      false
    ),
    // 机构收藏关系
    getShopCollectInfo() {
      this.collectParams.associatedIds = this.courseDetail.shopId;
      this.collectParams.collectType = 2;
      this.$Api.course
        .getCollectInfo(this.collectParams)
        .then((res) => {
          const idx = res.data.data.findIndex((item) => item == this.courseDetail.shopId);
          if (idx != -1) {
            this.shopCollected = true;
          } else {
            this.shopCollected = false;
          }
        })
        .catch(() => { });
    },
    // 收藏机构
    collectShopCourse(flag) {
      this.collectedShopCourse(flag);
    },
    collectedShopCourse: debounce(
      function (flag) {
        this.$Api.shop
          .collectShop({ shopId: this.courseDetail.shopId })
          .then((res) => {
            console.log(res);
            if (flag) {
              this.$Dialog.toast("关注成功");
            } else {
              this.$Dialog.toast("已取消关注", { type: "warning" });
            }
            this.getShopCollectInfo();
          })
          .catch(() => { });
      },
      1000,
      false
    ),
    // 课程列表页
    goCourseList() {
      this.$Jump.href("/courseList", {
        selectedParams: JSON.stringify(this.selectedInfo),
      });
    },
    // 加入购物车
    addCar(type) {
      let params = {
        courseId: this.courseId, type: type
      }
      if (this.selectSkuInfo.spec) {
        params.spec = JSON.stringify(this.selectSkuInfo.spec);
      }
      this.$Api.shop
        .addCar(params)
        .then(() => {
          if (type == 1) {
            this.$Dialog.toast("加入购物车成功");
            this.getCarList();
          } else {
            // this.$Jump.href("/cart");
            // let selectOrderList = [{ courseInfo: this.courseDetail }];
            // this.$Jump.href("/orderConfirm", {
            //   selectOrderList: JSON.stringify(selectOrderList),
            // });
            this.$Jump.href("/orderConfirm", { type: 2 });
          }
        })
        .catch((err) => {
          if (err.data.code == 910101) {
            this.$Dialog.confirm({
              message: "该课程暂未付款，是否前往订单中心，解锁该课程~",
              title: "提示", // 可选，不传则使用默认值'确认'
              onConfirm: () => {
                this.href("/orderList");
              }, // 确认后的操作，如调用删除API等
              onCancel: () => { },
            });
          }
        });
    },

    // 获取购物车列表
    getCarList() {
      this.$Api.shop
        .getCarList({ type: 1 })
        .then((res) => {
          this.$store.commit("user/setMyCarList", res.data.data);
        })
        .catch(() => { });
    },
    // 去购买
    goBuy() {
      this.$Jump.href("/orderConfirm", { courseId: this.courseId });
    },
  },
};
</script>
<style lang="scss" scoped>
.mar_top_20 {
  margin-top: 20px;
}

.mar_left_15 {
  margin-left: 15px;
}

.mar_left_20 {
  margin-left: 20px;
}

.mar_left_40 {
  margin-left: 40px;
}

.top_box {
  width: 100%;
  position: relative;

  .top_bg {
    width: 100%;
    height: 95%;
    position: absolute;
    left: 0;
    top: 0;
    background-repeat: no-repeat;
  }

  .top_bg_black {
    background: rgba(20, 20, 20, 0.4);
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .top_content {
    width: $pageMainWidth;
    z-index: 9;

    .top_left {
      width: 100%;

      .course_top_text {
        margin-top: 10px;
        color: #ffffff;

        .course_title {
          opacity: 0.6;
        }
      }

      .top_left_content {
        margin: 20px 0;
        color: #ffffff;

        .vedio_img {
          width: 480px;
          height: 270px;
          border-radius: 20px;
        }

        .video_info {
          height: 270px;
          margin-left: 25px;
          overflow: hidden;

          .video_title {
            font-weight: bold;
            font-size: 26px;
          }

          .subtitle {
            color: rgba(255, 255, 255, 0.6);
            margin-top: 10px;
          }
        }

        .top_right_content {
          width: 150px;

          .follow_icon {
            width: 45px;
            height: 45px;
          }

          .follow_box {
            color: rgba(255, 255, 255, 0.6);
          }
        }
      }
    }
  }
}

.content_box {
  padding-top: 15px;
  width: 100%;
  background: #f3f3f3;

  .content {
    width: $pageMainWidth;

    .content_left {
      .institution_info {
        width: 848px;
        height: 106px;
        background: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;

        .institution_info_left {
          min-width: 0;

          .avatar_img {
            flex-shrink: 0;
            width: 77px;
            height: 77px;
            border-radius: 50%;
          }

          .insitution_content {
            margin-left: 20px;
            min-width: 0;
            flex: 1;
          }

          .institution_name {
            font-weight: 600;
            font-size: 20px;
            color: #333333;
          }

          .institution {
            margin-left: 15px;
            width: 100px;
            height: 28px;
          }

          .institution_desc {
            margin-top: 10px;
            color: #999999;
          }
        }

        .btn_follow {
          width: 94px;
          height: 36px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 18px;
          color: #ffffff;

          .collect_icon {
            width: 24px;
            height: 24px;
            margin-right: 7px;
          }
        }

        .btn_followed {
          width: 94px;
          height: 36px;
          background: #f8f8f8;
          border-radius: 18px;
          color: #999999;
        }
      }

      .lecturer_info {
        width: 848px;
        background: #ffffff;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;

        .menu_list {
          border-bottom: 1px solid rgba(20, 20, 20, 0.1);

          .menu_one {
            line-height: 50px;
            margin: 0 10px;
            position: relative;
          }

          .line_active {
            position: absolute;
            bottom: 0;
            width: 50px;
            height: 2px;
            background: #13d6aa;
          }

          .active_text {
            color: #13d6aa;
            font-weight: 600;
          }
        }
      }

      .course_list_box {
        margin: 20px 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        border-radius: 10px;

        .recommend {
          font-weight: bold;
          font-size: 18px;
          color: #111111;
        }

        .more_btn {
          color: rgba(102, 102, 102, 1);
        }
      }

      .advertisement_box {
        margin-bottom: 40px;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        border-radius: 10px;

        // .advertisement_one{
        //     width: 45%;
        // }
        .advertisement_img {
          width: 390px;
          height: 156px;
          border-radius: 10px;
        }
      }
    }

    .content_right {
      margin-left: 20px;
      width: calc($pageMainWidth - 868px);

      .top_banner_right {
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding: 12px;
        // height: 560px;

        .top_banner_right_top {
          color: rgba(102, 102, 102, 1);
          // height: 310px;
          // border-bottom: 1px solid rgba(17, 17, 17, 0.1);
          box-sizing: border-box;

          .video_play_box {
            position: relative;
            width: 100%;
            height: 168px;

            .video_img {
              bottom: 0;
              left: 0;
              position: absolute;
              width: 100%;
              height: 168px;
              border-radius: 10px;
            }

            .play_icon {
              width: 44px;
              height: 44px;
            }

            .play_text {
              font-size: 14px;
              color: #ffffff;
              // line-height: 21px;
              text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
              z-index: 9;
            }
          }

          .price_box {
            width: 100%;
            color: #ff6619;

            .now_price_value {
              font-weight: 600;
              font-size: 26px;
            }

            .original_price {
              margin-left: 10px;
              font-size: 17px;
              color: #999999;
              text-decoration-line: line-through;
            }
          }

          .buy_btn_box {
            width: 100%;
          }

          .btn_buy {
            width: 100%;
            height: 42px;
            font-size: 14px;
            color: #ffffff;
            line-height: 42px;
            background: linear-gradient(90deg, #ff8a4c, #fe5e3c);
            border-radius: 24px;
            text-align: center;
            font-weight: 500;
          }

          .add_car {
            width: 100%;
            height: 42px;
            line-height: 42px;
            border-radius: 24px;
            border: 1px solid #ff6619;
            text-align: center;
            color: #ff6619;
            // font-weight: 600;
          }
        }

        .top_banner_right_bottom {
          .newest_course {
            font-weight: bold;
            font-size: 18px;
            color: #111111;
          }

          .active_course {
            font-size: 16px;
            // color: #13d6aa;
          }

          /* 基础样式 - 灰色 */
          .course-item {
            color: #606060;
            transition: color 0.3s ease;
            /* 添加过渡效果 */
          }

          /* 鼠标悬停样式 - 绿色 */
          .course-item:hover {
            color: #13d6aa !important;
            /* 使用 Element UI 的主题绿色 */
          }

          /* 如果需要更精确的 Element UI 绿色 */
          .course-item:hover {
            // color: var(--el-color-success) !important;
          }
        }
      }

      .course_list {
        margin-top: 10px;
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding: 12px;

        .recommend {
          font-weight: bold;
          font-size: 18px;
          color: #111111;
        }

        .more_btn {
          color: rgba(102, 102, 102, 1);
        }
      }
    }
  }
}
</style>
